import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { ChatService } from '../stokker/api/chat.service';

/** Auth-fejléces kép → blob-URL (gyorsítótárazva). Használat: [src]="path | chatBlob | async" */
@Pipe({ name: 'chatBlob' })
export class ChatBlobPipe implements PipeTransform {
  constructor(private chat: ChatService) {}

  transform(path: string | null | undefined): Observable<string | null> {
    return this.chat.blobUrl(path);
  }
}
